import { useEffect } from 'react';

import SubscriptionGroupStore from '@/stores/SubscriptionGroupStore';
import { Group } from '@/types/Content/Group';

export function useGetSubscriptionGroupListWithLifeEvents(): {
  subscriptionGroupListWithLifeEvents: Array<Group>;
  isSubscriptionGroupLoading: boolean;
} {
  const {
    subscriptionGroupListWithLifeEvents,
    loading: { getAllWithLifeEvents },
  } = SubscriptionGroupStore;

  useEffect(() => {
    SubscriptionGroupStore.getAllGroupsWithLifeEvents();
  }, []);

  return {
    subscriptionGroupListWithLifeEvents,
    isSubscriptionGroupLoading: getAllWithLifeEvents,
  };
}
